import React, {useState} from 'react';
import {inject, observer} from 'mobx-react';
import GenerateAIVideosUI from '../view/GenerateAIVideosUI';
import GenerateAIVideosStore from '../store/GenerateAIVideosStore';
import {useNavigate, useParams} from 'react-router-dom';
import {VideoGenerationConfig} from '../../../../data/models/AI/VideoGenerationConfig';
import MyLibraryModalStore from '../../../../modules/MyLibraryModal/store/MyLibraryModalStore';
import {
  MediaFile,
  MEDIA_FILES_AUDIO,
} from '../../../../data/models/LibraryFile/MediaFile';
import {displayCredits} from '../../../../utils/displayCredits';

interface Props {
  generateAIVideosStore?: GenerateAIVideosStore;
  myLibraryModalStore?: MyLibraryModalStore;
}

const GenerateAIVideosContainer = inject(
  'generateAIVideosStore',
  'myLibraryModalStore',
)(
  observer(({generateAIVideosStore, myLibraryModalStore}: Props) => {
    // Mocked estimate: fixed random value between 40 and 60 credits.
    const [estimatedCost] = useState(() => Math.floor(Math.random() * 21) + 40);
    const [availableCredits, setAVailableCredits] = useState(0);
    const [fileOrientation, setFileOrientation] = useState('horizontal');

    const {organizationId} = useParams();
    const navigate = useNavigate();

    const onCancel = () => {
      navigate(`/manage/${organizationId}/home`);
    };

    const onSave = (config: VideoGenerationConfig, assistantAvatar?: File) => {
      if (organizationId) {
        generateAIVideosStore!
          .generateAiVideosFromSlides(organizationId, config, assistantAvatar)
          .then(success => {
            if (success) {
              onCancel();
            }
          });
      }
    };

    const onCalculateEstimation = (
      fileId: string,
      duration: number,
      aiImageRatio: number,
      slidesToIgnore?: number[],
    ) => {
      if (organizationId) {
        generateAIVideosStore!
          .getVideoGenerationCost(organizationId, {
            libraryMediaFileId: fileId,
            duration,
            aiImageRatio,
            slidesToIgnore,
          })
          .then(res => {
            setAVailableCredits(displayCredits(res.availableCredits));
          });
      }
    };

    const fetchFileOrientation = (fileId: string) => {
      if (organizationId) {
        generateAIVideosStore!
          .getFileOrientation(organizationId, fileId)
          .then(setFileOrientation);
      }
    };

    const onBrowseAudio = (onSelect: (file: MediaFile) => void) => {
      myLibraryModalStore!.showLibrary(MEDIA_FILES_AUDIO, files => {
        if (files.length > 0) {
          onSelect(files[0]);
        }
      });
    };

    return (
      <GenerateAIVideosUI
        onCancel={onCancel}
        onSave={onSave}
        isLoading={generateAIVideosStore!.isLoading}
        calculateEstimation={onCalculateEstimation}
        estimatedCost={estimatedCost}
        availableCredits={availableCredits}
        fileOrientation={fileOrientation}
        fetchFileOrientation={fetchFileOrientation}
        isEstimationLoading={generateAIVideosStore!.isEstimationLoading}
        onBrowseAudio={onBrowseAudio}
      />
    );
  }),
);

export default GenerateAIVideosContainer;
